var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNosortDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10156 12.6289C4.77344 12.9844 4.19922 12.9844 3.87109 12.6289L1.24609 10.0039C0.890625 9.67578 0.890625 9.10156 1.24609 8.77344C1.57422 8.41797 2.14844 8.41797 2.47656 8.77344L3.625 9.89453V1.5C3.625 1.03516 4.00781 0.625 4.5 0.625C4.96484 0.625 5.375 1.03516 5.375 1.5V9.89453L6.49609 8.77344C6.82422 8.41797 7.39844 8.41797 7.72656 8.77344C8.08203 9.10156 8.08203 9.67578 7.72656 10.0039L5.10156 12.6289ZM14.7266 3.52344C15.082 3.85156 15.082 4.42578 14.7266 4.75391C14.3984 5.10938 13.8242 5.10938 13.4961 4.75391L12.375 3.63281V12C12.375 12.4922 11.9648 12.875 11.5 12.875C11.0078 12.875 10.625 12.4922 10.625 12V3.63281L9.47656 4.75391C9.14844 5.10938 8.57422 5.10938 8.24609 4.75391C7.89062 4.42578 7.89062 3.85156 8.24609 3.52344L10.8711 0.898438C11.1992 0.542969 11.7734 0.542969 12.1016 0.898438L14.7266 3.52344Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNosortDark);
export default __webpack_public_path__ + "static/media/nosort_dark.f3e2e6fe29cb6ef5a95aa1630a74bbd2.svg";
export { ForwardRef as ReactComponent };